import dayjs from 'dayjs'

export default function groupByDate<T extends { created_at: string }>(notifications: T[]): Record<string, T[]> {
  const groups: Record<string, T[]> = {}
  if (!Array.isArray(notifications) || notifications.length === 0) {
    return groups
  }

  // Cache reference dates to avoid recreating them for each item
  const now = dayjs()
  const yesterday = now.subtract(1, 'day')
  const sevenDaysAgo = now.subtract(7, 'day')

  notifications.forEach((n) => {
    const date = dayjs(n.created_at)
    let label = ''

    if (date.isSame(now, 'day')) {
      label = 'Today'
    } else if (date.isSame(yesterday, 'day')) {
      label = 'Yesterday'
    } else if (date.isAfter(sevenDaysAgo)) {
      label = date.format('dddd')
    } else {
      label = date.format('MMM D, YYYY')
    }

    if (!groups[label]) {
      groups[label] = []
    }
    groups[label]?.push(n)
  })

  return groups
}
